import React from 'react';
import { Squares2X2Icon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { ResolvedQRLink } from '../../../interfaces/qr_links';
import { getFullImageUrl } from '../../utils';

type Props = {
  link: ResolvedQRLink;
  onClick: () => void;
};

const LinkedCatalogCard: React.FC<Props> = ({ link, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="flex flex-row items-center bg-surface rounded-lg shadow-md p-3 cursor-pointer"
    >
      {link.image_url ? (
        <img
          src={getFullImageUrl(link.target_restaurant_id, link.image_url)}
          alt=""
          className="w-20 h-20 rounded-md object-cover flex-shrink-0"
        />
      ) : (
        <div className="w-20 h-20 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Squares2X2Icon className="w-8 h-8 text-on-surface-variant" />
        </div>
      )}
      <div className="flex flex-col ml-2 min-w-0">
        <div className="text-sm font-semibold text-on-surface truncate">
          {link.display_name}
        </div>
        {link.target_restaurant_name && (
          <div className="text-xs text-on-surface-variant italic truncate">
            {link.target_restaurant_name}
          </div>
        )}
        {link.description && (
          <div className="text-xs text-on-surface-variant line-clamp-2">
            {link.description}
          </div>
        )}
      </div>
      <ChevronRightIcon className="w-5 h-5 text-on-surface-variant flex-shrink-0 ml-2" />
    </div>
  );
};

export default LinkedCatalogCard;
